var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Data from './Data';
export { Data };
import { Purchases } from './Purchases';
export { Purchases };
// TODO это не должно экспортироваться
import { YandexGames } from './YandexGames';
export { YandexGames };
import { Ad } from './Ad';
export { Ad };
import { Auth } from './Auth';
export { Auth };
import { LeaderBoard } from './LeaderBoard';
export { LeaderBoard };
import { isTouchDevice } from '../utils';
import bridge from '@vkontakte/vk-bridge';
import { fakeBridgeSend } from './utils/fakeBridgeSend';
// import {Logger} from '../classes'
// const {log} = Logger.get('SDK', true)
export function init(cb) {
    if (FOR_VK) {
        // @ts-ignore
        window['bridge'] = bridge;
        if (DEVELOPMENT) {
            // @ts-ignore
            bridge.send = fakeBridgeSend;
        }
        bridge.send('VKWebAppInit', {}).then(function () { return cb(); });
    }
    if (FOR_YANDEX) {
        YandexGames.getPlayerOptions = { scopes: true };
        YandexGames.init({
            screen: {
                fullscreen: isTouchDevice(),
                orientation: { value: 'portrait', lock: true },
            },
        }, function () { return cb(); });
    }
    // if (FOR_OK) {
    //   ApiOK.init({}, () => cb())
    // }
}
export function ready() {
    if (FOR_YANDEX) {
        YandexGames.ready();
    }
    if (FOR_VK) {
        // TODO реализация или комментарий почему не нужно
    }
}
export function getLang() {
    return __awaiter(this, void 0, void 0, function () {
        var params, language;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!FOR_YANDEX) return [3 /*break*/, 2];
                    return [4 /*yield*/, YandexGames.getLang()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    if (FOR_VK) {
                        params = new URLSearchParams(location.search);
                        if (params.has('language')) {
                            language = params.get('language');
                            // 0 — русский; 1 — украинский; 2 — белорусский; 3 — английский;
                            return [2 /*return*/, ['0', '1', '2'].includes(language) ? 'ru' : 'en'];
                        }
                        return [2 /*return*/, 'ru'];
                    }
                    else {
                        return [2 /*return*/, 'en'];
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getLangSafe() {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getLang()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, 'ru'];
                case 3: return [2 /*return*/];
            }
        });
    });
}
